<template>
  <div
    class="pb-5 full-width"
    data-wizard-type="step-content"
    :data-wizard-state="active ? 'current' : ''"
  >
    <div class="d-flex justify-content-between align-items-end pr-5">
      <p>
        <strong>Danh sách sản phẩm con</strong>
      </p>
      <div class="mb-5">
        <span
          v-show="checkPermission('PRODUCT_INSERT')"
          v-b-tooltip.hover
          :title="isCreateProductBlocked ? createProductBlockedTooltip : ''"
          class="d-inline-block"
        >
          <b-button
            class="btn btn-primary font-weight-bolder btn-sm button"
            :disabled="isCreateProductBlocked"
            @click="onAddProduct"
          >
            <i style="font-size: 1rem" class="flaticon2-add-1"></i>Thêm mới
          </b-button>
        </span>
      </div>
    </div>

    <b-table
      v-if="products.length"
      :items="products"
      :fields="fields"
      class="table-bordered table-hover col-md-12"
    >
      <template v-slot:cell(productCode)="row">
        <div style="text-align: center">
          <span>{{ row.item.productCode }}</span>
        </div>
      </template>

      <template v-slot:cell(productName)="row">
        <div style="text-align: center">
          <span>{{ row.item.productName }}</span>
        </div>
      </template>

      <template v-slot:cell(quantity)="row">
        <div style="text-align: center">
          <b-form-input
            v-if="products[row.index].isEdit"
            type="text"
            v-model="products[row.index].quantity"
            size="sm"
            class="input-style text-right"
          ></b-form-input>
          <span v-else>{{ row.item.quantity }}</span>
        </div>
      </template>

      <template v-slot:cell(productComboPrice)="row">
        <div style="text-align: center">
          <b-form-input
            v-if="products[row.index].isEdit"
            type="text"
            v-model="products[row.index].productComboPrice"
            v-mask="mask"
            size="sm"
            class="input-style text-right"
          ></b-form-input>
          <span v-else>
            {{ row.item.productComboPrice || 0 }}
          </span>
        </div>
      </template>

      <template v-slot:cell(productComboRate)="row">
        <div style="text-align: center">
          <b-form-input
            v-if="products[row.index].isEdit"
            type="text"
            v-model="products[row.index].productComboRate"
            size="sm"
            class="input-style text-right"
          ></b-form-input>
          <span v-else> {{ row.item.productComboRate || 0 }}% </span>
        </div>
      </template>

      <template v-slot:cell(actions)="row">
        <div class="d-flex justify-content-center">
          <v-icon
            v-if="products[row.index].isEdit"
            class="mr-2 text-primary"
            small
            @click="$emit('update-product', row.index)"
            >mdi-check</v-icon
          >
          <v-icon
            v-else
            small
            class="mr-2 text-warning"
            @click="$emit('edit-product', row.index, row.item)"
            v-b-tooltip
            title="Cập nhật Combo"
            >mdi-pencil</v-icon
          >
          <v-icon
            small
            class="mr-2 text-danger"
            @click="$emit('delete-product', row.item)"
            v-b-tooltip
            title="Xóa"
            >mdi-delete</v-icon
          >
        </div>
      </template>
    </b-table>
  </div>
</template>

<script>
import { currencyMask } from '@/utils/common';
import companyCatalogFlagsMixin from '@/view/mixins/companyCatalogFlags.mixin';

export default {
  name: 'ProductComboSection',
  mixins: [companyCatalogFlagsMixin],
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    products: {
      type: Array,
      default: () => [],
    },
    fields: {
      type: Array,
      required: true,
    },
    checkPermission: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      mask: currencyMask,
    };
  },
  methods: {
    onAddProduct() {
      if (!this.ensureCanCreateProduct()) {
        return;
      }
      this.$emit('add-product');
    },
  },
};
</script>
